export const RULE_TYPES = {
  INCLUDE_ALL: 'include_all',
  BY_JOB_TITLE: 'user.job_title_id',
  BY_UNITS: 'user.unit_ids',
} as const;

export const OPERATORS = {
  IN: 'IN',
  NOT_IN: 'NOT_IN',
  ANY_IN: 'ANY_IN',
  NOT_ANY_IN: 'NOT_ANY_IN',
  ALL_IN: 'ALL_IN',
  NOT_ALL_IN: 'NOT_ALL_IN',
} as const;

export type RuleType = (typeof RULE_TYPES)[keyof typeof RULE_TYPES];
export type Operator = (typeof OPERATORS)[keyof typeof OPERATORS];
